import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { GasThree } from '../models/gasthree.model';
import { AuthService } from '../services/auth.service';
import { ConfigurationService } from '../services/configuration.service';

@Injectable()
export class GasThreeService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    get() {
        return this.http.get('api/GasThree', this.getAuthHeader(true));
    }

    getDataListByPage(page: number, pagesize: number, orderBy: string, isDesc: boolean, search?: string) {
        if (search != null && search !== '') {
            return this.http.get(`api/GasThree/GetDataListByPage/${page}/${pagesize}/${orderBy}/${isDesc}/${search}`, this.getAuthHeader(true));
        }
        return this.http.get(`api/GasThree/GetDataListByPage/${page}/${pagesize}/${orderBy}/${isDesc}`, this.getAuthHeader(true));
    }

    createUpdate(gasthree: GasThree) {
        return this.http.post('api/GasThree', gasthree, this.getAuthHeader(true));
    }

    getLastUpdateDate() {
        return this.http.get('api/GasThree/GetLastUpdateDate', this.getAuthHeader(true));
    }

    getStatistics(monthsCount: number) {
        return this.http.get('api/GasThree/GetStatistics/' + monthsCount, this.getAuthHeader(true));
    }

    getCacheStatistics(monthsCount: number) {
        return this.http.get('api/GasThree/getCacheStatistics/' + monthsCount, this.getAuthHeader(true));
    }

    getGasThreeById(id: number) {
        return this.http.get(`api/GasThree/GetById/${id}`, this.getAuthHeader(true));
    }

    getCurrentYear() {

        return this.http.get(`api/GasThree/GetCurrentYear`, this.getAuthHeader(true));
    }

    delete(id: number) {
        return this.http.get(`api/GasThree/Delete/${id}`, this.getAuthHeader(true));
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        var options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/gasthree.service.ts